import React from 'react'
import { useParams } from 'react-router-dom'

import { useDelForSettings } from '../data'
import { Attachment } from './Attachment'
import { DataForConfirmationData } from './DataForConfirmation'
import { DeliveryForecastInformation } from './DeliveryForecastInformation'
import { DeliveryScheduleDetailsContainer } from './DeliveryScheduleDetails'
import { Header } from './Header'
import { Title } from './Title'

export const DeliveryForecast: React.FC = () => {
  const { id } = useParams()
  const { data: isConfirmationActive } = useDelForSettings()

  return (
    <>
      <Title
        deliveryForecastId={id as string}
        isConfirmationActive={isConfirmationActive?.isConfirmationActive!}
      />

      <Header deliveryForecastId={id as string} />

      <DeliveryForecastInformation
        deliveryForecastId={id as string}
        isConfirmationActive={isConfirmationActive?.isConfirmationActive!}
      />

      {isConfirmationActive?.isConfirmationActive && (
        <DataForConfirmationData deliveryForecastId={id as string} />
      )}

      <DeliveryScheduleDetailsContainer
        deliveryForecastId={id as string}
        isConfirmationActive={isConfirmationActive?.isConfirmationActive!}
      />

      <Attachment deliveryForecastId={id as string} />
    </>
  )
}
